module.exports = __webpack_public_path__ + "img/skype.1361163a.png";